import React, { useEffect, useState } from 'react'
import Neet_Banner from './Neet_Banner'
import axios from 'axios';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import NeetCards from './NeetCards';
import Neet_StudyMaterials from './NeetStudyMaterials';
import NeetTestSeriesCards from './NeetTestSeriesCards';
import { useLocation } from 'react-router-dom';
import CivilContent from '../../AllPageContent/AllPageContent';

const NeetHomePage = () => {
    const location = useLocation();
    const path = location.pathname;
    const [courses, setCourses] = React.useState([]);
    const [testSeries, setTestSeries] = React.useState([]);
    const [studyMaterials, setStudyMaterials] = React.useState([]);
    const [aboutNeet, setAboutNeet] = useState('');
    console.log(testSeries);
    useEffect(() => {
        document.title = "NEET| Classes, Study Material, Test Series";
        const fetchNeetData = async () => {
            try {
                const [coursesRes, testSeriesRes, studyMaterialsRes, aboutNeet] = await Promise.all([
                    axios.get(BASE_URL + '/neet/user/courses'),
                    axios.get(BASE_URL + '/neet/user/testseries'),
                    axios.get(BASE_URL + '/neet/user/study-materials'),
                    axios.get(BASE_URL + `/getAboutDetails/about-neet-exam`)
                ]);
                setCourses(coursesRes.data.data);
                setTestSeries(testSeriesRes.data.data);
                setStudyMaterials(studyMaterialsRes.data.data);
                setAboutNeet(aboutNeet.data.data);
            } catch (error) {
                console.error("Error fetching NEET data:", error);
            }
        };

        fetchNeetData();
    }, []);
    console.log(aboutNeet);
    return (
        <div>
            <Neet_Banner path={path} />
            {path === '/neet/classes' && <NeetCards courses={courses} heading="Neet Courses" />}
            {path === '/neet/study-material' && <Neet_StudyMaterials studyMaterials={studyMaterials} heading="Neet Courses" />}
            {path === '/neet/testseries' && <NeetTestSeriesCards testSeries={testSeries} heading="Neet Test Series" />}
            {path === '/neet/about' && <CivilContent paragraphs={aboutNeet.Description} />}
        </div>
    )
}

export default NeetHomePage

{/* <p
                className="text-dark"
                style={{
                    fontFamily: "'Rubik', sans-serif",
                    fontSize: '0.95rem',
                    lineHeight: '1.5',
                    letterSpacing: '1.2px',
                    color: '#a54a06',
                    margin: '0.25rem 0',
                    padding: '0.5rem 0.75rem',
                    backgroundColor: '#fff8f2',
                    borderLeft: '4px solid #a54a06',
                    borderRadius: '0.25rem',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                }}
            >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum quam modi fugit
                ipsam cumque cum, facilis nisi. Voluptatibus eos laudantium enim iste libero
                eius minima ullam quod harum.
            </p> */}